import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Card from "../../Components/Card/Card.js";
import CardHeader from "../../Components/Card/CardHeader.js";
import CardBody from "../../Components/Card/CardBody.js";
import GridContainer from "../../Components/Grid/GridContainer.js";
import GridItem from "../../Components/Grid/GridItem.js";
import { connect, useSelector } from "react-redux";
import { Button } from "react-bootstrap";
import { ChangePasswordForm } from "Components/My Settings/ChangePassword";
import { BasicProfile } from "Components/My Settings/BasicProfile";
import PropTypes from "prop-types";

const styles = {
  cardTitleWhite: {
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "bolder",
    fontFamily: "Roboto",
    marginBottom: "3px",
    textDecoration: "none",
    fontSize: "1.5rem",
  },
  sectionCard: {
    padding: "16px",
    border: "1px solid #e0e0e0",
    borderRadius: "4px",
    marginBottom: "16px",
  },
};

const useStyles = makeStyles(styles);

const MODAL_TYPES = {
  NONE: "NONE",
  CHANGE_PASSWORD: "CHANGE_PASSWORD",
  EDIT_PROFILE: "EDIT_PROFILE",
};

function AdminSettings(props) {
  const classes = useStyles();
  const { userId } = useSelector((state) => state.adminUser.adminUser);
  const lang = props.language ?? "en";
  const [formType, setFormType] = useState(MODAL_TYPES.NONE);

  return (
    <div>
      <ChangePasswordForm
        id={userId}
        show={formType === MODAL_TYPES.CHANGE_PASSWORD}
        onClose={() => setFormType(MODAL_TYPES.NONE)}
        onSubmit={() => setFormType(MODAL_TYPES.NONE)}
        language={lang}
      />

      <BasicProfile
        userId={userId}
        show={formType === MODAL_TYPES.EDIT_PROFILE}
        onClose={() => setFormType(MODAL_TYPES.NONE)}
        onSubmit={() => setFormType(MODAL_TYPES.NONE)}
        language={lang}
      />

      <GridContainer>
        <GridItem xs={12} sm={12} md={8}>
          <Card>
            <CardHeader color="primary">
              <h4 className={classes.cardTitleWhite}>Settings</h4>
            </CardHeader>
            <CardBody>
              <div className={classes.sectionCard}>
                <h5>Password</h5>
                <p className="text-muted mb-2">Change your account password.</p>
                <Button
                  variant="primary"
                  size="sm"
                  onClick={() => setFormType(MODAL_TYPES.CHANGE_PASSWORD)}
                >
                  Change Password
                </Button>
              </div>
              <div className={classes.sectionCard}>
                <h5>Profile</h5>
                <p className="text-muted mb-2">Update your profile information.</p>
                <Button
                  variant="success"
                  size="sm"
                  onClick={() => setFormType(MODAL_TYPES.EDIT_PROFILE)}
                >
                  Edit Profile
                </Button>
              </div>
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
    </div>
  );
}

const mapStateToProps = (state) => ({
  language: state.adminUser.adminUser.language,
});

AdminSettings.propTypes = {
  language: PropTypes.string,
};

export default connect(mapStateToProps)(AdminSettings);
